module.exports = ".setInputHeight {\r\n    margin-top: 20px;\r\n}\r\n\r\n.setLabelHeight {\r\n    margin-top: 10px;\r\n}\r\n\r\n.add-btn {\r\n    border-radius: 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/edit-timesheet/edit-timesheet.component.css
// module id = ./src/app/admin/edit-timesheet/edit-timesheet.component.css
// module chunks = main